import { render, staticRenderFns } from "./btLogo.vue?vue&type=template&id=38d02bca&scoped=true"
import script from "./btLogo.vue?vue&type=script&lang=js"
export * from "./btLogo.vue?vue&type=script&lang=js"
import style0 from "./btLogo.vue?vue&type=style&index=0&id=38d02bca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d02bca",
  null
  
)

export default component.exports